import menu from './en-US/menu';
import pages from './en-US/pages';
import pwa from './en-US/pwa';

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  ...menu,
  ...pages,
  ...pwa,
};
